import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRedoDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowRedoDown"><Path d="M17 19L21 15L17 11" stroke="currentColor" strokeLinecap="square"/><Path d="M20 15L2.5 15L2.5 5.5L12 5.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowRedoDown;
